<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap fill-height>
      <v-flex sm10 v-if="currentUser.accountTypeID !== 5">
        <SignUp></SignUp>
      </v-flex>
      <v-flex sm2="sm2" v-if="currentUser.accountTypeID !== 5">
        <SignUpCount></SignUpCount>
      </v-flex>
      <v-flex d-flex xs12>
        <v-layout row wrap>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex d-flex>
                <Installation> </Installation>
              </v-flex>
              <v-flex d-flex>
                <ActiveStore @getCount="getCount"></ActiveStore>
              </v-flex>
              <v-flex d-flex>
                <OpenLeads></OpenLeads>
              </v-flex>
              <v-flex d-flex v-if="currentUser.accountTypeID !== 5">
                <OpenInvoice></OpenInvoice>
              </v-flex>
              <v-flex d-flex v-if="currentUser.accountTypeID !== 5">
                <ManualAndReadyInvoice> </ManualAndReadyInvoice>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex>
            <v-layout class="mt-2 mb-2 ml-1 mr-1" row wrap v-if="currentUser.accountTypeID !== 5">
              <v-layout row wrap v-if="currentUser.accountTypeID == 1">
                <v-flex>
                  <Cancelation></Cancelation>
                </v-flex>
                <v-flex>
                  <Revenue></Revenue>
                </v-flex>
              </v-layout>
              <v-layout v-else>
                <v-flex>
                  <Cancelation></Cancelation>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex d-flex xs12 sm4>
        <v-layout column fill-height>
          <v-flex shrink v-if="checkRightStatus(55)">
            <v-card color="info" dark hover to="/location/0/new">
              <v-card-text>
                <h1 class="text-xs-center headline font-weight-light">Sign Up</h1>
                <h1 class="text-xs-center caption font-weight-light">
                  Create new organization with location
                </h1>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex d-flex>
            <Comment></Comment>
          </v-flex>
          <v-flex child-flex d-flex v-if="currentUser.accountTypeID === 1">
            <RevenueByProduct> </RevenueByProduct>
          </v-flex>
          <div v-if="!$vuetify.breakpoint.xs">
            <v-flex d-flex xs12 v-if="currentUser.accountTypeID <= 2">
              <UserActivity></UserActivity>
            </v-flex>
          </div>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm8>
        <v-layout row wrap>
          <v-flex xs12 v-if="!$vuetify.breakpoint.xs">
            <Calendar></Calendar>
          </v-flex>
          <v-flex d-flex xs12 v-if="currentUser.accountTypeID <= 2">
            <v-layout row wrap>
              <v-flex d-flex sm6 >
                <Activity></Activity>
              </v-flex>
              <v-flex d-flex sm6 >
                <Feedback />
              </v-flex>
            </v-layout>

            </v-flex>
          <v-flex xs12 sm6>
            <Stores></Stores>
          </v-flex>
          <v-flex v-if="!$vuetify.breakpoint.xs" xs12 sm6>
            <Promotion :activeStore="activeStore"></Promotion>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import dashbaordService from "../service.js";
import SignUpCount from "./Tiles/SignUpCount";
// import PreviousCancel from "./Tiles/PreviousCancel";
// import CurrentMonthCancel from "./Tiles/CurrentMonthCancel";
import Feedback from "../../Tickets/components/Feedback";
import Installation from "./Tiles/Installation";
import ManualAndReadyInvoice from "./Tiles/ManualAndReadyInvoice";
import ActiveStore from "./Tiles/ActiveStore";
import OpenInvoice from "./Tiles/OpenInvoice";
import OpenLeads from "./Tiles/OpenLeads";
import Stores from "./Charts/Stores";
import Calendar from "./Calendar";
import Comment from "./Comment";
import Activity from "./Activity";
import UserActivity from "./UserActivity";
import SignUps from "./SignUps";
import Promotion from "./Charts/Promotion";
import SignUp from "./Charts/SignUp";
import RevenueByProduct from "./RevenueByProduct";
import AnimatedNumber from "animated-number-vue";
import { mapGetters } from "vuex";
const Cancelation = () => import("./Tiles/Cancelation");
const Revenue = () => import("./Tiles/Revenue");

export default {
  name: "home",
  data() {
    return {
      ticketActive: null,
      leadActive: null,
      activeStore: 0
    };
  },
  components: {
    Activity,
    SignUps,
    Feedback,
    UserActivity,
    SignUpCount,
    Cancelation,
    Revenue,
    OpenLeads,
    OpenInvoice,
    Stores,
    ActiveStore,
    Comment,
    Installation,
    AnimatedNumber,
    RevenueByProduct,
    Promotion,
    Calendar,
    ManualAndReadyInvoice,
    SignUp
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
    leadShowStatus() {
      if (
        this.currentUser.accountTypeID !== 5 &&
        this.currentUser.accountTypeID !== 6 &&
        this.currentUser.accountTypeID !== 3
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    getCount(val) {
      this.activeStore = val;
    }
  }
};
</script>

<style scoped></style>
